import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import DatePicker from 'react-datepicker';
import { Checkbox } from '../../../../../components/Checkbox';
import { Dropdown } from '../../../../../components/Dropdown';
import { ManualDropdown } from '../../../../../components/ManualDropdown';
import { FormField } from '../../../../../components/FormFields';
import { DecoratorLabel, Input } from '../../../../../components/Input';
import { Calendar } from '../../../../../components/Icon';
import { IconRightDecorator } from '../../../../../components/Icon/IconRightDecorator';
import { Loader } from '../../../../../components/Loader';
import { deleteVehicleProperty, initiateNewVehicleValue, setNewVehicleValue } from '../../../actions';
import { selectNewVehicle, selectNewVehicleValue, selectVehicle } from '../../../selectors';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { selectWork } from '../../../../Api/selectors';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../constants';

dayjs.extend(customParseFormat);

const DROPDOWN_OPTIONS = {};

const MANUAL_DROPDOWN_OPTIONS = {
  design: ['design_1', 'design_2'],
};

const Container = styled.div`
  margin-bottom: 24px;
  .formField {
    .label {
      text-transform: capitalize;
      margin-bottom: 6px;
      color: #6c757d;
    }
  }
`;

const STATE = {
  value: '',
};

/* eslint-disable react/prefer-stateless-function */
class VehicleCreateFieldComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.initiateValue();
  }

  isCheckbox() {
    return ['wok', 'pending_recall'].indexOf(this.props.type) > -1;
  }

  isDropbox() {
    return this.props.type in DROPDOWN_OPTIONS;
  }

  isManualDropbox() {
    return this.props.type in MANUAL_DROPDOWN_OPTIONS;
  }

  wrap(children) {
    switch (this.props.type) {
      default:
        return <FormField label={this.formFieldLabel()}>{children}</FormField>;
    }
  }

  formFieldLabel() {
    if (this.isCheckbox()) return null;
    return this.lbl(`vehicle.property.${this.props.type}`);
  }

  dropdown() {
    const vals = DROPDOWN_OPTIONS[this.props.type];

    const options = vals.map(val => ({
      label: this.lbl(`vehicle.property.${this.props.type}.${val}`),
      value: val,
    }));

    const value = options.find(o => o.value == this.props.value);
    return <Dropdown options={options} value={value} onChange={pair => this.props.setValue(pair.value)} />;
  }

  manualDropdown() {
    const vals = MANUAL_DROPDOWN_OPTIONS[this.props.type];
    return (
      <ManualDropdown
        model={'vehicle'}
        key={this.props.type}
        type={this.props.type}
        editable={true}
        deletable={this.props.vehicle && this.props.vehicle[this.props.type]}
        options={vals}
        onChange={value => this.props.setValue(value)}
        onReset={() => this.props.setValue('')}
        onDeleteValue={value =>
          this.props.deleteProperty(this.props.values?.id, this.props.type, result => {
            if (result === true) {
              this.props.setValue('');
            }
          })
        }
        onManual={value => {
          return this.props.setValue(value, this.props.type + '_manual');
        }}
      />
    );
  }

  reset() {
    this.setState({ ...STATE });
  }

  isDate() {
    return ['date_first_allowance', 'last_tenaamstelling', 'date_apk_expiry'].indexOf(this.props.type) > -1;
  }

  isYearsRangeInput() {
    return ['model_year', 'delivered_from'].indexOf(this.props.type) > -1;
  }

  datePicker() {
    let format = this.props.value?.charAt(2) == '-' ? 'DD-MM-YYYY' : undefined;

    let selected = this.props.value && this.props.value !== 'null' && dayjs(this.props.value, format);

    return (
      <>
        <DatePicker
          dateFormat="dd-MM-yyyy"
          selected={selected && selected != 'Invalid Date' && selected.toDate()}
          onChange={date => {
            let d = dayjs(date).format('YYYY-MM-DD hh:mm:ss');
            d && this.props.setValue(d);
          }}
        />
        <IconRightDecorator icon={<Calendar />} />
      </>
    );
  }

  yearRangeInput() {
    const arrFromDateStr = this.props.value.split('-');
    const startDate = arrFromDateStr.splice(0, 3).join('-');
    const finishDate = arrFromDateStr.join('-');
    const yearFormatDateStr = [dayjs(startDate).format('YYYY'), dayjs(finishDate).format('YYYY')];
    return (
      <Input
        key={this.props.type}
        value={this.props.value.length > 30 ? `${yearFormatDateStr[0]}-${yearFormatDateStr[1]}` : this.props.value}
        onChange={evt => this.props.setValue(evt.target.value)}
        rightDecoration={<DecoratorLabel>start-end</DecoratorLabel>}
      />
    );
  }

  render() {
    if (this.props.work) return <Loader small />;
    return <Container>{this.wrap(this.renderField())}</Container>;
  }

  renderField() {
    if (this.props.value === undefined) return null;

    if (this.isCheckbox()) {
      return (
        <Checkbox
          checked={this.props.value === '1'}
          onChange={() => {
            const value = this.props.value === '1' ? '0' : '1';
            return this.props.setValue(value);
          }}
        >
          {this.lbl(`vehicle.property.${this.props.type}`)}
        </Checkbox>
      );
    }

    if (this.isDate()) {
      return this.datePicker();
    }

    if (this.isYearsRangeInput()) {
      return this.yearRangeInput();
    }

    if (this.isDropbox()) {
      return this.dropdown();
    }

    if (this.isManualDropbox()) {
      return this.manualDropdown();
    }

    switch (this.props.type) {
      case 'number_of_previous_owners':
        return (
          <Input
            type="number"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
            rightDecoration={<DecoratorLabel>Persons</DecoratorLabel>}
          />
        );
      // case 'model_year':
      //   return (
      //     <Input
      //       key={this.props.type}
      //       value={this.props.value}
      //       onChange={evt => this.props.setValue(evt.target.value)}
      //       rightDecoration={<DecoratorLabel>start-end</DecoratorLabel>}
      //     />
      //   );
      case 'production_date':
        return (
          <Input
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
            rightDecoration={<DecoratorLabel>YYYY-MM</DecoratorLabel>}
          />
        );
      case 'delivered_from':
        return (
          <Input
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
            rightDecoration={<DecoratorLabel>start-end</DecoratorLabel>}
          />
        );
    }
  }
}

VehicleCreateFieldComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(REQUEST_VEHICLE_PROPERTY_UPDATE),
    value: selectNewVehicleValue(ownProps.type),
    values: selectNewVehicle(),
    vehicle: selectVehicle(ownProps.vehicle_id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setValue(value, name = null) {
      name = name ?? ownProps.type;
      dispatch(setNewVehicleValue(name, value));
    },
    deleteProperty(vehicleId, propertyName, callback) {
      dispatch(deleteVehicleProperty(vehicleId, propertyName, callback));
    },
    initiateValue() {
      dispatch(initiateNewVehicleValue(ownProps.type));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const VehicleCreateField = compose(
  withConnect,
  withRouter,
)(VehicleCreateFieldComp);
